import React from 'react';
import { SectionLayout } from '@/components/section-layout';

export function SurveysPage() {
  return (
    <SectionLayout title="Surveys">
      {/* Surveys content will go here */}
    </SectionLayout>
  );
} 